module.exports = __webpack_public_path__ + "img/product_113.0fed1f0.webp";